import {
  PowerSchedules,
  PowerTypes,
  RouterStatuses,
} from "@/components/constants.js"

export default (self) => {
  return {
    number: {
      component: "TextFieldSearchFilter",
    },
    simProvider: {
      component: "SelectSearchFilter",
      attributes: {
        items: [
          { value: "", name: "All" },
          ...self.simProviderList.map((value) => ({ value, name: value })),
        ],
      },
    },
    billPayer: {
      component: "SelectSearchFilter",
      attributes: {
        items: [
          { value: "", name: "All" },
          ...self.billPayerList.map((value) => ({ value, name: value })),
        ],
      },
    },
    iccid: {
      component: "TextFieldSearchFilter",
      name: "iccid",
    },
    cameras: {
      component: "TextFieldSearchFilter",
      name: "cameraName",
    },
    routerType: {
      component: "SelectSearchFilter",
      attributes: {
        items: [
          { value: "", name: "All" },
          ...self.routerTypes.map((value) => ({ value, name: value })),
        ],
      },
    },
    serialNumber: {
      component: "TextFieldSearchFilter",
      name: "serialNumber",
    },
    description: {
      component: "TextFieldSearchFilter",
      name: "description",
    },
    status: {
      component: "SelectSearchFilter",
      attributes: {
        items: [{ value: "", name: "All" }, ...RouterStatuses],
      },
    },
    powerType: {
      component: "SelectSearchFilter",
      attributes: {
        items: [{ value: "", name: "All" }, ...PowerTypes],
      },
    },
    powerSchedule: {
      component: "SelectSearchFilter",
      attributes: {
        items: [{ value: "", name: "All" }, ...PowerSchedules],
      },
    },
  }
}
